import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Input, Radio, Button, notify } from 'app/components';
import { requestEvent } from '../landing-page/api';
import useLoginModal from '../login/useLoginModal';
import { isValidURL } from '../../utils/commonUtils';
import './style';


const RequestEvent = () => {
  const [inputLink, setInputLink] = useState('');
  const [selectedOption, setSelectedOption] = useState(null);
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const loginModal = useLoginModal();

  const { userData } = useSelector((state) => state.app);

  const sendRequestEvent = () => requestEvent(inputLink, selectedOption, (data) => {
    // console.log('Event request successful:', data);
    notify('success', 'request submitted', {
      position: 'bottom-center',
      duration: 2000,
    });

    setTimeout(() => {
      navigate('/');
    }, 2100);
  });

  const handleSubmit = () => {
    if (!inputLink || !isValidURL(inputLink)) {
      setError('Enter a valid URL, eg. www.example.com');
      return;
    }
    if (!selectedOption) {
      setError('Select an option to proceed');
      return;
    }
    setError('');

    if (!userData?.email) {
      loginModal.onOpen();
      loginModal.callback.current = sendRequestEvent;
    } else sendRequestEvent();
  };

  const changeHandler = (e) => {
    const link = e.target.value;
    setError('');
    setInputLink(link);
  };

  const handleRadioChange = (option) => {
    setSelectedOption(option);
    setError('');
    // console.log(option);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="pt-[151px] h-full flex justify-center bg-grey-5 pad">
      <Helmet>
        <title>Events Around You</title>
        <meta
          name="title"
          content="Request for Events in India | Buy Tickets on Take My Tickets| Take My Tickets"
        />
        <meta
          name="description"
          content="Request to add to sell and buy tickets for concerts, sports events, music festivals, and more on India's top online ticket marketplace."
        />
      </Helmet>
      
      <div className="w-[502px] h-[600px] p-9 flex flex-col gap-6 bg mobile-container">
        <h1 className="heading-36 mobile-head">
          Request to add an event for resale!
        </h1>

        <div className="flex flex-col gap-3">
          <p className="label-16 text-[#878787] mobile-text">
            Paste the URL of the event you want to be added{' '}
          </p>
          <Input
            placeholder="Paste link here"
            width="100%"
            value={inputLink}
            validationStatus={error && 'error'}
            onChange={changeHandler}
            helpText={error && error}
          />
        </div>

        <div className="flex flex-col gap-3">
          <p className="label-16 text-[#878787] mobile-text">
            Do you want to buy or sell tickets for this event?{' '}
          </p>
          <div className="flex gap-6">
            <Radio
              label="Buy"
              checked={selectedOption === 'buy'}
              onChange={() => handleRadioChange('buy')}
            />
            <Radio
              label="Sell"
              checked={selectedOption === 'sell'}
              onChange={() => handleRadioChange('sell')}
            />
          </div>
          {error && !selectedOption && (
            <p className="text-12 text-[#D92D20]">
              Select an option to proceed
            </p>
          )}
        </div>

        <div className="flex p-4 gap-6 items-center justify-center bg-green infocard">
          <p className="heading-36">✌️</p>
          <p className="text-14 text-[#009D64]">
            Thanks for taking your time to fill this! We will do our best to add
            this event as soon as possible.
          </p>
        </div>

        <Button className="w-full"
          onClick={handleSubmit}>
          Submit
        </Button>
      </div>
    </div>
  );
};

export default RequestEvent;
